$(() => {

  // Hide the filters until the page is loaded and they can be resized
  $('.loading-cube--grid').hide(0);
  $('.recipe-filters, .recipe-grid').css({
    visibility: 'visible',
    opacity: 1,
  });

  $('.recipe-filter select')
    .change((e) => {
      const currentSelect = e.currentTarget.id;
      const filters = [];
      $('.detail-container__close').trigger('click');
      $('.recipe-filter select option:selected').each(function () {
        const filter = $(this).val();
        if (filter !== '') {
          filters.push(filter);
        }
      });

      filterRecipes(filters);

      filterFilters(filters);

      // resizeSelects(currentSelect);
    })
    .change();

  // reset the filters
  $('.filters--reset').on('click', () => {
    const filters = [
      'rum',
      'difficulty',
      'season',
      'type',
      'taste',
      'recipe-type',
    ];

    closeDetailPanel();

    filters.forEach((filter) => {
      $(`#filter--${filter}`).val(filter).change();
    });
  });

  // update filters based on clicking tags in recipe details
  $('.recipe-grid').on('click', '.recipe-tags a', (e) => {
    e.preventDefault();
    const tagHrefArray = e.target.href.split('/');
    let tag;
    let filter;
    if (tagHrefArray[tagHrefArray.length - 1] !== '') {
      tag = tagHrefArray[tagHrefArray.length - 1];
      filter = tagHrefArray[tagHrefArray.length - 2];
    } else {
      tag = tagHrefArray[tagHrefArray.length - 2];
      filter = tagHrefArray[tagHrefArray.length - 3];
    }

    closeDetailPanel();
    scrollToFilters();

    $(`#filter--${filter}`).val(tag).change();
  });

  // Resize the filter selects to fit the content selected
  // function resizeSelects(currentSelect) {
  //   $('#width-tmp-option').html($('#' + currentSelect + ' option:selected').text());
  //   const selectWidth = $('#width-tmp-select').width();
  //   $('#' + currentSelect).width(selectWidth);
  // }

  // Scroll to filters
  function scrollToFilters() {
    const scrollPosition = $('.page__headline')[0].offsetTop;
    console.log(scrollPosition);
    $('html, body').animate({
      scrollTop: scrollPosition,
    }, 350);
  }

  // Filter the recipes in the grid
  function filterRecipes(filters) {
    const recipes = $('.recipe-item');

    $.each(recipes, (i, recipe) => {
      let show = true;
      $.each(filters, (j, val) => {
        const value = val.toLowerCase();
        if (!$(recipe).hasClass(value)) {
          show = false;
        }
      });
      if (show) {
        $(recipe).addClass('visible').show();
      } else {
        $(recipe).removeClass('visible').hide();
      }
    });
    var gridItems = $('.recipe-item.visible');
  }

  // Filter the filters list to only show the rums filter when food is selected
  function filterFilters(filters) {

    const isFood = $.inArray('food', filters);
    const cocktailFilters = '.filter--difficulty, .filter--season, .filter--type, .filter--taste';

    if (isFood > 0) {
      $(cocktailFilters).hide();
    } else {
      $(cocktailFilters).show();
    }
  }

  function setUrlParameterFilters() {
    const url = window.location.href;
    const parameter = url.split('?').pop().split('=');
    if (parameter.length > 1) {
      const filter = parameter[0];
      const tag = parameter[1];
      return $(`#filter--${filter}`).val(tag);
    }
    return;
  }

  function init() {
    const filters = [];
    setUrlParameterFilters();
    $('.recipe-filter select option:selected').each(function () {
      const filter = $(this).val();
      if (filter !== '') {
        filters.push(filter);
      }
    });
    filterRecipes(filters);
    $('.recipe-filter select').select2({ minimumResultsForSearch: Infinity });
  }

  function closeDetailPanel() {
    $('.detail-container__close').trigger('click');
  }

  init();
});
